import { api } from "../../util";

export const getLocationsApiCall = (payload = {}) => {
  let url = "/locations";

  return api.get(url, {
    params: {
      page: payload.page,
      limit: payload.limit,
      filter: payload.filter || {},
      sort: payload.sort,
      //   search: payload.search,
    },
  });
};
